const discoverQueryParams = name => {
  const pairs = window.location.search.substring(1).split("&");
  return pairs
    .filter(p => p.indexOf(`${name}=`) === 0)
    .map(p => decodeURIComponent(p.split("=")[1]));
};

const discoverQueryParam = name => {
  const xs = discoverQueryParams(name);
  return xs.length === 0 ? void 0 : xs[xs.length - 1];
};

export default {
  discoverQueryParam
};



// WEBPACK FOOTER //
// ./src/services/location.js